import { useState } from 'react'
import Swal from 'sweetalert2'
import KampaniePlacowkiService from '@/services/KampaniePlacowkiService'

export default function usePlacowkiActions(kampaniaId, refreshData, onKampaniaUpdated) {
	const [processingId, setProcessingId] = useState(null)
	const [isRemoving, setIsRemoving] = useState(false)

	const handleMarkAsUndone = async item => {
		const itemId = item?._id
		if (!itemId || !item?.doneDate) return

		const confirm = await Swal.fire({
			title: 'Oznaczyc jako niewykonane?',
			text: `Placowka: "${item?.placowkaNazwa || '-'}"`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Tak, oznacz',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		setProcessingId(itemId)
		const result = await KampaniePlacowkiService.markAsUndone(itemId)
		setProcessingId(null)

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie oznaczyc placowki jako niewykonanej',
				icon: 'error',
			})
			return
		}

		await refreshData()
	}

	const handleMarkAsDone = async item => {
		const itemId = item?._id
		if (!itemId || item?.doneDate) return

		const confirm = await Swal.fire({
			title: 'Oznaczyc jako wykonane?',
			text: `Placowka: "${item?.placowkaNazwa || '-'}"`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Tak, oznacz',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		setProcessingId(itemId)
		const result = await KampaniePlacowkiService.markAsDone(itemId)
		setProcessingId(null)

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie oznaczyc placowki jako wykonanej',
				icon: 'error',
			})
			return
		}

		await refreshData()
	}

	const handleRemoveSelected = async (placowkaIds, clearSelection) => {
		const ids = Array.isArray(placowkaIds) ? placowkaIds.filter(Boolean) : []
		if (!kampaniaId || ids.length === 0) return

		const confirm = await Swal.fire({
			title: 'Czy na pewno?',
			text:
				ids.length === 1
					? 'Usunac zaznaczona placowke z kampanii?'
					: `Usunac ${ids.length} zaznaczonych placowek z kampanii?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Tak, usun',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		setIsRemoving(true)
		const result = await KampaniePlacowkiService.removeFromCampaign(kampaniaId, ids)
		setIsRemoving(false)

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie usunac placowek z kampanii',
				icon: 'error',
			})
			return
		}

		if (result?.data?.kampania) {
			onKampaniaUpdated?.(result.data.kampania)
		}

		clearSelection?.()
		await refreshData()
	}

	return {
		processingId,
		isRemoving,
		handleMarkAsDone,
		handleMarkAsUndone,
		handleRemoveSelected,
	}
}
